<template>
  <div style="height: 100%">
    <div class="inject-home" v-if="homeShow">
      <div>
        <a-button type="primary" block @click="onClickAdd">
          {{ $t('publish.tagAdd') + $t('edit.hpInfo.scenePH') }}
        </a-button>
        <div class="list-title">{{ $t('edit.hpInfo.currentHP') }}</div>
      </div>

      <HotspotList v-for="(value, k) in hotspotObj" :key="k" :itemObj="value" :selectedId="currHotId"
        @renameItem="renameItem" @deleteItem="deleteItem" @editItem="editItem" @click.native="onClickItem(value)">
      </HotspotList>
    </div>

    <HotpointScene v-if="sceneShow" :defaultValue="editTarget" @clickBack="clickBack" @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore" @change="handleHotspotChange"></HotpointScene>

    <!--重命名-->
    <a-modal v-model="renameVisible" :title="$t('actionTitles.rename')" :destroyOnClose="true" @ok="handleConfirm">
      <div>
        <div>
          <a-input v-model="newName" :addonBefore="$t('edit.name')" :placeholder="renameObj.title"></a-input>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import HotpointScene from "../hotpoint/HotpointScene";
import HotspotList from "../hotpoint/HotspotList";

import { mapGetters } from "vuex";

export default {
  components: {
    HotpointScene,
    HotspotList,
  },
  data() {
    return {
      hotspotObj: {},
      homeShow: true,
      sceneShow: false,
      renameVisible: false,
      allHotIcon: [],
      newName: "",
      renameObj: {},
      editTarget: null,
      currHotId: "",
      isAddNew: true,
    };
  },
  computed: {
    ...mapGetters(["vrbase", "currentScenesId", "userInfo"]),
  },
  watch: {
    currentScenesId() {
      this.handleInitListData();
    },
  },
  created() {
    this.handleInitListData();
  },
  mounted() { },
  methods: {
    handleInitListData() {
      const hotports = this.vrbase.scenes[this.currentScenesId].hotspot;
      // 獲取已存在的轉場熱點數據
      let tempObj = {};
      for (let key in hotports) {
        if (hotports[key].type === "scene") {
          tempObj[key] = hotports[key];
        }
      }
      this.hotspotObj = tempObj;
    },
    onClickItem(item) {
      console.log("觸發onClickitem的item:", item);
      this.currHotId = item.hotspot_id;
      lookto(item.ath, item.atv);
    },
    editItem(itemObj) {
      this.sceneShow = true;
      this.homeShow = false;
      this.editTarget = itemObj;
      this.isAddNew = false;
    },
    onClickAdd() {
      this.editTarget = null;
      this.sceneShow = true;
      this.homeShow = false;
      this.isAddNew = true;
    },
    clickBack(hotspot) {
      this.sceneShow = false;
      this.homeShow = true;
      if (this.isAddNew) {
        removeHotspot(hotspot.hotspot_id);
      }
    },
    clickDelete(hotspot) {
      this.deleteItem(hotspot);
      this.sceneShow = false;
      this.homeShow = true;
    },
    handleListOption(value, option) {
      console.log(value, option);
    },
    saveDataToStore({ key, data }) {
      this.sceneShow = false;
      this.homeShow = true;
      let vrbase = this.vrbase;
      this.$set(this.hotspotObj, key, data); // 更新本地
      vrbase.scenes[this.currentScenesId].hotspot[key] = data;
      this.$store.dispatch("setVRBase", vrbase);
      this.$store.dispatch("saveVRBase", { vrbase, showLoading: true });
    },
    renameItem(selectedItem) {
      this.renameObj = selectedItem;
      this.renameVisible = true;
    },
    deleteItem(selectedItem) {
      let hotspot = this.vrbase.scenes[this.currentScenesId].hotspot;
      this.$delete(this.hotspotObj, selectedItem.hotspot_id); // 過濾後的數據不是同一個對象，單獨更新本地
      this.$delete(hotspot, selectedItem.hotspot_id); // 更新store數據
      this.$store.dispatch("setVRBase", this.vrbase);
      removeHotspot(selectedItem.hotspot_id);
    },
    handleConfirm() {
      let item = this.vrbase.scenes[this.currentScenesId].hotspot[
        this.renameObj.hotspot_id
      ];
      this.$set(
        this.hotspotObj[this.renameObj.hotspot_id],
        "title",
        this.newName
      ); // 更新本地
      this.$set(item, "title", this.newName); // 更新store數據
      this.$store.dispatch("setVRBase", this.vrbase);
      this.renameVisible = false;
      //更新krpano
      this.handleHotspotChange(this.renameObj, {})
      // reset data
      this.newName = "";
      this.renameObj = {};
    },
    handleHotspotChange(val, oldVal) {
      setHotspot(val, oldVal);
    },
  },
};
</script>